import { render, staticRenderFns } from "./ZZLColumnDesign.vue?vue&type=template&id=ca62da64"
import script from "./ZZLColumnDesign.vue?vue&type=script&lang=js"
export * from "./ZZLColumnDesign.vue?vue&type=script&lang=js"
import style0 from "./ZZLColumnDesign.vue?vue&type=style&index=0&id=ca62da64&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports